import React from "react";
import { Link } from "react-router-dom";
import "../../common/bg.css";
import "./c.css";
import WebsiteName from "../../common/WebsiteName/WebsiteName";
import Navbar from "../../common/Navbar/NavBar";
import Location from "../../common/Location/Location";
import Footer from "../../common/Footer/Footer";
export default function C_info() {
  return (
    <>
      <section className="bgImageCommon">
        <WebsiteName />
        <Navbar />
        <Location title="C++ Programming" />
        <section>
          <div className="cBody">
            <div id="cardDIV">
              <h1 className="text-dark" id="laguage_Title">
                C++
              </h1>
              <p className="text-secondary" id="Language_Para">
                C++ is a structured programming language. Programming in C++ is
                modular i.e. we are able to break the complex code into smaller
                pieces (subdividing a computer program into separate
                sub-programs) and combine them using functions, classes, and
                objects. This results in cleaner code and makes maintenance much
                easier.
                <br />
                C++ is quite similar to C programming. In fact, C++ supports all
                the features offered with C with the addition to various other
                important features like object-oriented programming, operator
                overloading, exception and error handling, the namespace
                feature, and many more.
                <br />
                C++ is an object-oriented programming language and includes
                classes, inheritance, polymorphism, data abstraction and
                encapsulation. C++ has a rich function library. C++ allows
                exception handling, and function overloading which are not
                possible in C. C++ is a powerful, efficient and fast language.
              </p>
              <Link
                name=""
                id=""
                class="btn btn-danger"
                to="/Courses"
                role="button">
                {"<< "}back
              </Link>
            </div>
          </div>
        </section>
        <Footer />
      </section>
    </>
  );
}
